<template>
  <div class="pt-3">
    <h6
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
      v-if="params.column.colId == 'CollectionDone'"
    >
      {{ VALUE == true ? $t("CollectionPickComplete") : $t("CollectionPickNotComplete") }}
    </h6>
    <h6
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
      v-else-if="params.column.colId == 'CollectionPackageDone'"
    >
		{{ VALUE == true ? $t("CollectionPackComplete") : $t("CollectionPackNotComplete") }}
      
    </h6>
    <h6 style="font-weight: 400; margin: 0px !important; padding: 0px !important" v-else>
      {{ VALUE }}
    </h6>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VALUE: "",
    };
  },
  created() { 
    this.VALUE = this.params.value;
  },
};
</script>
